import { Injectable } from "@angular/core";
import { EventoCalendarioAgenda } from "src/app/admihair/api/dto/evento-calendario-agenda";

@Injectable()
export class AgendaEventoRenderService {

  renderizarLabelRecursos(titulo: string, quantidadeEventos: number) {
    return {
      html: `
            <div class="flex align-items-center gap-2 cursor-pointer">
              <span class="flex align-items-center hover:text-primary">
                <i class="pi pi-user mr-2 line-height-1"></i>
                ${titulo}
              </span>
              <span class="flex align-items-center justify-content-center
                  w-2rem h-2rem border-solid border-1 border-green-400
                  border-round-xl text-color text-sm
                ">
                ${quantidadeEventos}
              </span>
            </div>
          `
    };
  }


  renderizarEventoCompacto(time: string, title: string, icone: string): string {
    return `
      <div class="flex align-items-center justify-content-start h-full p-1
          white-space-nowrap overflow-hidden text-overflow-ellipsis">
          <span class="flex align-items-center font-bold mr-2">
            <i class="pi pi-clock mr-1 line-height-1"></i>
            ${time}
          </span>
          <span class="flex align-items-center overflow-hidden">
            <i class="pi pi-${icone} mr-1 line-height-1"></i>
            - ${title}
          </span>
      </div>`;
  }

  renderizarEventoCompleto(time: string, title: string, icone: string, tipo: string, status: string): string {
    if (tipo === 'BLOQUEIO') {
      return `
        <div class="flex flex-column p-1">
          <span class="flex font-bold">
            <i class="pi pi-clock mr-1"></i>${time}
          </span>
          <span class="flex">
            <i class="pi pi-${icone} mr-1"></i>BLOQUEIO
          </span>
        </div>`;
    }

    return `
      <div class="flex flex-wrap justify-content-between p-1">
          <div class="flex flex-column">
            <span class="font-bold">
              <i class="pi pi-clock mr-1"></i>${time}
            </span>
            <span>
              <i class="pi pi-${icone} mr-1"></i>${title}
            </span>
          </div>
          <span class="product-badge border-solid border-1 h-fit admihair-text-black">
            ${status}
          </span>
      </div>`;
  }

  obterQuantidadeEventosDoColaborador(idColaborador: number, eventos: EventoCalendarioAgenda[]): number {
    return eventos.filter(e => e.profissionalId === idColaborador && e.tipo === 'AGENDAMENTO').length;
  }
}